exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wrap[data-v-059c500a] {\n  width: 18.375rem;\n  margin: 0 auto 1rem auto;\n  font-size: 0;\n}\ntext-align center[data-v-059c500a] {\n  overflow: hidden;\n}\n.title[data-v-059c500a] {\n  margin: 0.96rem 0 0.8125rem;\n}\n.wrap img[data-v-059c500a] {\n  width: 100%;\n}\n", ""]);

